"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCarousel = useCarousel;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _reactSpring = require("react-spring");
function useCarousel(numPages) {
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    index = _useState2[0],
    set = _useState2[1];
  var next = function next() {
    return set(function (state) {
      return Math.min(state + 1, numPages);
    });
  };
  var prev = function prev() {
    return set(function (state) {
      return Math.max(0, state - 1);
    });
  };
  var transitions = (0, _reactSpring.useTransition)(index, function (p) {
    return p;
  }, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    trail: 750
  });
  return {
    index: index,
    next: next,
    prev: prev,
    transitions: transitions
  };
}
//# sourceMappingURL=carousel.js.map